<template>
  <div class="frame">
    <DebugTile
      bottom right
      v-bind:data="frame"
      v-if="$options.isDebugMode"
    />

    <component
      v-bind:key="frame.selector"
      v-bind:is="frame.type"
      v-bind:data="frameData"
      v-bind:meta="frameMeta"
      v-on:sendForm="sendForm"
      v-on:event="passEvent"
    />
  </div>
</template>

<script>
import * as FrameTypes from './frames';
import FrameModel from '../../lib/FrameModel';
import { isDebugMode } from '../../lib/helpers';

export default {
  name: 'Frame',

  isDebugMode: isDebugMode(),

  components: {
    ...FrameTypes,
  },

  props: {
    frame: {
      type: FrameModel,
      required: true,
    },
  },

  computed: {
    frameData() {
      return this.frame.getFrameData();
    },

    frameMeta() {
      return this.frame.getFrameMeta();
    },
  },

  methods: {
    sendForm(data) {
      this.$emit('sendForm', data);
    },

    passEvent(data) {
      this.$emit('frameEvent', data);
    },
  },
};
</script>
